import { FunctionComponent } from 'react';
import GenericIcons from '../../../components/generics/GenericIcons';
import '../../../css/PublicAboutUsPage.css';

const Component04: FunctionComponent = () => {
  const teamMembers = [
    {
      name: 'Luis Gutiérrez',
      role: 'Director',
      description: 'Ph.D. en Ingeniería Eléctrica',
      icon: 'luisGutierrez'
    },
    {
      name: 'Daniel Olivares',
      role: 'Director Alterno',
      description: 'Ph.D. en Ingeniería Eléctrica y Computación',
      icon: 'danielOlivares'
    },
    {
      name: 'Bernardo Severino',
      role: 'Investigación Principal',
      description: 'Dr.-Ing. (c) en Ingeniería Eléctrica',
      icon: 'bernardoSeverino'
    },
    {
      name: 'José Cruz',
      role: 'Ingeniero de planificación y control presupuestario',
      description: 'Ingeniero Civil de Industrias - Electricista',
      icon: 'joseCruz'
    },
    {
      name: 'Ignacio Pérez',
      role: 'Ingeniero de Proyectos',
      description: 'Ingeniero Civil en Energía. Universidad Adolfo Ibáñez',
      icon: 'ignacioPerez'
    },
    {
      name: 'Luis Nilo',
      role: 'Transferencia Tecnológica',
      description: 'Magíster en Gestión y Emprendimiento Tecnológico',
      icon: 'luisNilo'
    }
  ];

  const TeamMember: FunctionComponent<{ member: (typeof teamMembers)[0] }> = ({ member }) => {
    return (
      <div className='public-about-us-page-team-member-container-component-four'>
        <figure className='public-about-us-page-team-member-figure-component-four'>
          <div className='vdr-about-team-photo'>
            <GenericIcons
              icon={member.icon}
              imageStyle={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </div>
          <figcaption className='public-about-us-page-team-member-description-container'>
            <h3 className='public-about-us-page-team-member-name-text'>{member.name}</h3>
            <p className='public-about-us-page-team-member-role-text'>
              <strong>{member.role}</strong>
            </p>
            <p className='public-about-us-page-team-member-description-text'>
              {member.description}
            </p>
          </figcaption>
        </figure>
      </div>
    );
  };

  return (
    <div className='public-about-us-page-component-four-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>Nuestro Equipo y Colaboradores</h2>
        <small>UAI · CENTRA</small>
      </div>
      <div className='public-about-us-page-team-member-panel-component-four'>
        {teamMembers.map((member, idx) => (
          <TeamMember key={`team-member-${idx}`} member={member} />
        ))}
      </div>
      <div className='vdr-about-team-text'>
        <p className='public-about-us-page-text'>
          Detrás de VisiónDERRED se encuentra un equipo compuesto por profesionales con una
          profunda experiencia en el sector energético, ingeniería eléctrica. Cada uno de nosotros
          está comprometido con los valores y objetivos del proyecto, trabajando de manera
          colaborativa para crear soluciones tecnológicas que marquen una diferencia significativa
          en la industria. Nuestros ingenieros y especialistas se esfuerzan constantemente por
          ofrecer herramientas innovadoras y un servicio excepcional.
        </p>
        <p className='public-about-us-page-text'>
          Agradecemos a Datafy, que colaboró en la fase inicial del proyecto con el desarrollo de la
          primera versión de esta plataforma.
          <a
            className='vdr-about-credit-link'
            href='https://datafy.cl/'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Datafy (se abre en una pestaña nueva)'>
            <GenericIcons icon='LogoDatafy' className='vdr-about-credit-logo' />
          </a>
        </p>
      </div>
    </div>
  );
};

export default Component04;
